import React from "react";
import {jobHistoryService} from "../../jwt/_services/configuration/jobHistoryService";

export const jobHistoryProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await jobHistoryService.getFilterOptions();

        const jobs = listItems?.jobs.map(job => ({
            id: job,
            value: job,
            label: <label>{ job }</label>
        }));

        const actions = listItems?.actions.map(action => ({
            id: action,
            value: action,
            label: <label>{ action }</label>
        }));

        return [jobs, actions]
    } catch (error) {
        console.log(error.message)
    }
}